<div style="overflow-y: auto; height: calc(100vh - 178px);">
  <div class="container-fluid">
    <div class="row justify-content-center pt-5">
      <div class="col-11">
        <span class="rm-title rm-title-3">Employee Information</span><br/><br/>
        <!-- <span>
            Set employee job titles and manage their access for efficient team control.
          You may temporarily suspend an employee's access without permanently deleting their employee profile. While suspended,
          the employee will not have access to your company profile or any associated deals.<br/><br/>
        </span> -->
      </div>
    </div>
    <br/>
    <!--    WELL START-->
    <div class="row justify-content-center" style="padding-bottom: 150px;">
      <div class="col-11">
        <app-user-card [firstName]="selectedEmployee?.user?.firstName"
                        [lastName]="selectedEmployee?.user?.lastName"
                        [displayName]="selectedEmployee?.user?.email"
                        [borderColor]="'transparent'"
                        [sideColor]="'#002150'"
                        [image]="selectedEmployee?.user?.imageUrl"
                        [size]="userCardSize.LG"
        ></app-user-card>
        <form [formGroup]="userForm"
              (ngSubmit)="save()">
          <!--          row start-->
          <div class="row">
            <div class="col-6 pt-2">
              <mat-label style="font-size: medium; margin-top: 25px;">Employee Title</mat-label>
              <mat-form-field class="form-field" appearance="outline">
                <input class="form-input" matInput formControlName="title"
                        placeholder="e.g. Operations Manager"/>
              </mat-form-field>
            </div>
            <div class="col-12 pt-2">
              <p>
                You have the option to temporarily suspend an employee from your company without permanently deleting their profile.
                While suspended, the employee will not have access to your company or any associated deals.
              </p>
              <p>
                Upon choosing to re-activate them, all previous permissions and settings will be reinstated.
              </p>
              <mat-checkbox class="pt-2" color="primary" formControlName="isEmployeeActive">Employee is
                Active
              </mat-checkbox>
            </div>
          </div>
          <div class="row pt-4">
            <div class="col-12 text-end">
              <button type="submit" mat-raised-button color="primary">SAVE</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

